import { msAjax } from 'lib/axios';
import { IResponse, ICreateParams, IConfig } from 'interfaces/base';

class FormStore {
  signatures = (data: { accessToken: string | string[] | null | undefined }) => {
    return msAjax.post('/signatures/create', data);
  };

  getAddress = () => {
    return msAjax.get<IResponse<any>>('/resources/states');
  };

  getConfig = () => {
    return msAjax.get<IResponse<IConfig>>('/configs');
  };

  createCompany = (paramsData: any) => {
    return msAjax.post<IResponse<ICreateParams>>('/companies/create', paramsData);
  };
  draft = (paramsData: any) => {
    return msAjax.post<IResponse<any>>('/companies/draft', paramsData);
  };
}

export default new FormStore();
